import { IonText } from "@ionic/react";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useWorkOrderStore } from "../store/wo-order";
import { TranslationMessagesContext } from "../util/Translations";
import WorkOrderCard from "./WorkOrderCard";
import { maxResults } from "../hooks/useQueryExec";

const DownloadedWorkOrders: React.FC = () => {
  const downloadedWo = useWorkOrderStore((state) => state.downloadedWo);
  const { translatedMessages } = useContext(TranslationMessagesContext);
  const [searchText, setSearchText] = useState("");

  const allRows = useMemo(
    () => downloadedWo.flatMap((d) => d.row),
    [downloadedWo]
  );

  useEffect(() => {
    setFilteredRows(allRows);
  }, [allRows]);

  const [filteredRows, setFilteredRows] = useState(allRows);

  const hasDownloadedWo = downloadedWo.length > 0;
  const noResult = filteredRows.length <= 0;

  const handleFilter = useCallback(
    async (queryString: string) => {
      if (queryString) {
        // Case-insensitive substring match across all column values
        // (replaces Fuse.js fuzzy matching, which returned near-miss values).
        const needle = queryString.toLowerCase();
        const res = allRows.filter((row) =>
          row.Columns.some((col) =>
            String(col.Value ?? "").toLowerCase().includes(needle)
          )
        );
        setFilteredRows(res.slice(0, maxResults));
      } else {
        setFilteredRows(allRows.slice(0, maxResults));
      }
      setSearchText(queryString);
    },
    [allRows]
  );

  return (
    <>
      {hasDownloadedWo && (
        <WorkOrderCard
          woLink={downloadedWo.at(0)?.woLink ?? ""}
          storesRoute={downloadedWo.at(0)?.storesRoute}
          storesTab={downloadedWo.at(0)?.storesTab}
          allRows={allRows}
          filteredRows={filteredRows}
          filterString={searchText}
          onFilter={handleFilter}
        />
      )}
      <IonText
        hidden={hasDownloadedWo && !noResult}
        color={"default"}
        style={{ padding: "16px", display: "inline-block" }}
      >
        {translatedMessages["NoResultsFound"]?.MessageText ||
          "No results found."}
      </IonText>
    </>
  );
};

export default DownloadedWorkOrders;
